import Api from '@/api/api.js'

// Compte à rebours de la licence, demandé à chaque changement d'écran et par la barre du haut (05/10/2026) :
// les appels simultanés partagent la même requête et une réponse sert 60 s, secondes restantes recalculées.
const COMPTE_A_REBOURS_MS = 60000
let compteARebours = null

export default {
    getAttributionAutomatiqueConsultation(id) {
        return Api().get('/parametres/consultations/' + id + '/attribution-automatique').then(response => response.data)
    },
    saveAttributionAutomatiqueConsultation(id, data) {
        return Api().put('/parametres/consultations/' + id + '/attribution-automatique', data).then(response => response.data)
    },
    getRemunerationPrestations() {
        return Api().get('/parametres/remuneration/prestations').then(response => response.data)
    },
    getMedecinRemuneration(user_id) {
        return Api().get('/parametres/medecins/' + user_id + '/remuneration').then(response => response.data)
    },
    saveMedecinRemuneration(user_id, data) {
        return Api().put('/parametres/medecins/' + user_id + '/remuneration', data).then(response => response.data)
    },
    checkIfPatientEstAssure(patient_id) {
        const promise = Api().get('/assurances/patient/'+patient_id+'/est_assure')
        return promise.then(response => response.data)
    },

    getPatientInfoAssurance(data) {
        const promise = Api().get('/assurances/patient/'+data.patient_id+'/info_assurance')
        return promise.then(response => response.data)
    },

    getPrixPrestationAssur(data) {
        const promise = Api().get('/parametres/prix/injectable/'+data.patient_id+'/'+data.injectable_id)
        return promise.then(response => response.data)
    },

    addAssurance(data) {
        const promise = Api().post('/assurances/store', data)
        return promise.then((response) => response.data)
    },

    getAssurance() {
        const promise = Api().get('/assurances')
        return promise.then(response => response.data)
    },

    deleteCompagnie(data) {
        const promise = Api().put('/assurances/delete', data)
        return promise.then((response) => response.data)
    },
    
    getAssuranceById(assurance_id) {
        const promise = Api().get('/assurances/show/'+assurance_id)
        return promise.then(response => response.data)
    },

    importerSouscripteur(assurance_id, user_id, data, medicaments) {
        const promise = Api().post('/assurances/souscripteurs/'+assurance_id+'/'+user_id+'/importer', data, medicaments)
        return promise.then((response) => response.data)
    },

    saveSouscripteur(data) {
        const promise = Api().post('/assurances/souscripteurs/store', data)
        return promise.then((response) => response.data)
    },

    // Société à convention directe : travailleurs et familles retrouvés à l'accueil (04/10/2026).
    // Accueil : assurance, convention ou société absente créée en un geste (04/10/2026).
    creerAssuranceRapide(data) {
        return Api().post('/assurances/creation-rapide', data).then(response => response.data)
    },
    creerSouscripteurRapide(assurance_id, data) {
        return Api().post('/assurances/' + assurance_id + '/souscripteurs/creation-rapide', data).then(response => response.data)
    },

    rechercherMembresConvention(assurance_id, q) {
        return Api().get('/assurances/' + assurance_id + '/membres/recherche', { params: { q } }).then(response => response.data)
    },
    // Accueil : travailleur ou membre de sa famille absent, ajouté tout de suite à la convention (04/10/2026).
    creerMembreConvention(assurance_id, data) {
        return Api().post('/assurances/' + assurance_id + '/membres', data).then(response => response.data)
    },

    listeSouscripteur(assurance_id) {
        const promise = Api().get('/assurances/'+assurance_id+'/souscripteurs/liste')
        return promise.then((response) => response.data)
    },

    deleteSouscripteur(data) {
        const promise = Api().put('/assurances/souscripteurs/'+data.souscripteur_id+'/delete')
        return promise.then((response) => response.data)
    },

    getSouscripteurById(data) {
        const promise = Api().get('/assurances/'+data.assurance_id+'/souscripteurs/'+data.souscripteur_id)
        return promise.then((response) => response.data)
    },

    listeAllPrestationSouscripteur(data) {
        const promise = Api().get('/assurances/'+data.assurance_id+'/souscripteurs/'+data.souscripteur_id+'/prestations')
        return promise.then((response) => response.data)
    },

    listePrestationSouscripteur(data) {
        const promise = Api().get('/assurances/'+data.assurance_id+'/souscripteurs/'+data.souscripteur_id+'/prestations/'+data.est_exclu)
        return promise.then((response) => response.data)
    },

    updatePrestation(assurance_id, souscripteur_id, data) {
        const promise = Api().put('/assurances/'+assurance_id+'/souscripteurs/'+souscripteur_id+'/prestations', data)
        return promise.then((response) => response.data)
    },

    listeAllMedCategorieSouscripteur(data) {
        const promise = Api().get('/assurances/'+data.assurance_id+'/souscripteurs/'+data.souscripteur_id+'/categorie_meds')
        return promise.then((response) => response.data)
    },

    listeMedCategorieSouscripteur(data) {
        const promise = Api().get('/assurances/'+data.assurance_id+'/souscripteurs/'+data.souscripteur_id+'/categorie_meds/'+data.est_exclu)
        return promise.then((response) => response.data)
    },

    listeAnalyseSouscripteur(data) {
        const promise = Api().get('/assurances/'+data.assurance_id+'/souscripteurs/'+data.souscripteur_id+'/analyses')
        return promise.then((response) => response.data)
    },

    updateAnalyse(assurance_id, souscripteur_id, data) {
        const promise = Api().put('/assurances/'+assurance_id+'/souscripteurs/'+souscripteur_id+'/analyses', data)
        return promise.then((response) => response.data)
    },

    addGroupeAssurance(data) {
        const promise = Api().post('/assurances/groupes/store', data)
        return promise.then((response) => response.data)
    },

    getGroupeAssurance() {
        const promise = Api().get('/assurances/groupes')
        return promise.then(response => response.data)
    },

    deleteGroupeAssurance(data) {
        const promise = Api().put('/assurances/groupes/delete', data)
        return promise.then((response) => response.data)
    },

    getGroupeAssuranceById(groupe_id) {
        const promise = Api().get('/assurances/groupes/'+groupe_id)
        return promise.then(response => response.data)
    },

    getAssuranceSansGroupe() {
        const promise = Api().get('/assurances/sans_groupe')
        return promise.then(response => response.data)
    },

    configBaseActifAssurance(data) {
        const promise = Api().put('/assurances/groupes/config/type_config/'+data.type_config+'/'+data.groupe_id)
        return promise.then((response) => response.data)
    },

    getTousTypeConsultations() {
        const promise = Api().get('/parametres/consultations')
        return promise.then(response => response.data)
    },

    getCategorieMedicament() {
        const promise = Api().get('/parametres/medicaments/categorie')
        return promise.then(response => response.data)
    },

    getMedicamentList() {
        const promise = Api().get('/parametres/medicaments')
        return promise.then(response => response.data)
    },

    setExclusion(data) {
        const promise = Api().post('/parametres/prestations/exclusions/store', data)
        return promise.then(response => response.data)
    },

    getListExclusByPrestation(data) {
        const promise = Api().get('/parametres/prestations/'+data.type_prestation+'/assurance/'+data.assurance_id+'/souscripteur/'+data.souscripteur_id+'/exclusions')
        return promise.then(response => response.data)
    },

    assignGroupToAssurance(data) {
        const promise = Api().put('/groupes/groupe_assurance/assign/assurance', data)
        return promise.then(response => response.data)
    },

    getAssignedExamensToUsers(data){
        const promise = Api().post('/parametres/examens/managers',data)
        return promise.then(response => response.data)
    },
    
    assignExamensToUsers(user_id,data){
        const promise = Api().post('/parametres/examens/managers/'+user_id+'/assign',data)
        return promise.then(response => response.data)
    },

    getConfigInfoClinique(data){
        const promise = Api().get('/config/info_clinique/'+data)
        return promise.then(response => response.data)
    },

    getListeAllBonConsommable(){
        const promise = Api().get('/config/bon_consommable/liste')
        return promise.then(response => response.data)
    },

    saveConfigInfoClinique(data){
        // Api() defaults to JSON. Let the browser set the multipart boundary for files.
        const promise = Api().post('/config/info_clinique/store', data, {
            headers: { 'Content-Type': undefined }
        })
        return promise.then(response => response.data)
    },

    saveConsommableBonVisibilite(data){
        const promise = Api().post('/config/bon_consommable/type_consultation/store', data)
        return promise.then(response => response.data)
    },

    saveChirurgie(data){
        const promise = Api().post('/config/chirurgie/store', data)
        return promise.then(response => response.data)
    },

    saveKChirurgie(data){
        const promise = Api().post('/config/k_chirurgie/store', data)
        return promise.then(response => response.data)
    },

    getListeChirurgies(){
        const promise = Api().get('/config/chirurgies')
        return promise.then(response => response.data)
    },

    deleteItem(data){
        const promise = Api().post('/config/item/delete', data)
        return promise.then(response => response.data)
    },

    saveBilanSante(data){
        const promise = Api().post('/bilan-sante', data)
        return promise.then(response => response.data)
    },

    getListeBilanSante(){
        const promise = Api().get('/bilan-sante/liste')
        return promise.then(response => response.data)
    },

    deleteBilanSante(data){
        const promise = Api().post('/bilan-sante/delete', data)
        return promise.then(response => response.data)
    },

    getConsumableOfConsultation(data){
        const promise = Api().post('/config/consumables', data)
        return promise.then(response => response.data)
    },

    saveConsumableOfConsultation(data){
        const promise = Api().post('/config/consumables/add', data)
        return promise.then(response => response.data)
    },

    deleteConsumableOfConsultation(data){
        const promise = Api().post('/config/consumables/delete', data)
        return promise.then(response => response.data)
    },

    getListeTypeAdmission(data_type){
        const promise = Api().get('/parametres/admissions/'+data_type+'/liste')
        return promise.then(response => response.data)
    },

    storeAdmission(data){
        const promise = Api().post('/parametres/admissions/store', data)
        return promise.then(response => response.data)
    },

    deleteAdmissionByType(data){
        const promise = Api().post('/parametres/type-admissions/delete', data)
        return promise.then(response => response.data)
    },

    importAnalyse(data){
        const promise = Api().post('/parametres/importer/analyse', data)
        return promise.then(response => response.data)
    },

    importPrestation(data){
        const promise = Api().post('/parametres/importer/prestations', data)
        return promise.then(response => response.data)
    },

    // Import par lots des gros fichiers : dépôt, traitement d'un lot, abandon
    demarrerImportPrestation(data) {
        return Api().post('/parametres/importer/prestations/demarrer', data).then(response => response.data)
    },

    importerLotPrestation(import_id, debut) {
        return Api().post('/parametres/importer/prestations/' + import_id + '/lot', { debut: debut }).then(response => response.data)
    },

    annulerImportPrestation(import_id) {
        return Api().delete('/parametres/importer/prestations/' + import_id).then(response => response.data)
    },

    getDifferentialComputing() {
        const promise = Api().get('/consultations/calcul-differentiel')
        return promise.then(response => response.data)
    },

    getCountDown() {
        if (!compteARebours || (compteARebours.recu && Date.now() - compteARebours.recu >= COMPTE_A_REBOURS_MS)) {
            const entree = { recu: 0 }
            entree.promesse = Api().get('/countdown').then(response => {
                entree.recu = Date.now()
                return response.data
            }, erreur => {
                if (compteARebours === entree) compteARebours = null
                throw erreur
            })
            compteARebours = entree
        }
        const entree = compteARebours
        return entree.promesse.then(donnees => {
            const copie = donnees === undefined ? donnees : JSON.parse(JSON.stringify(donnees))
            const ecoule = Math.floor((Date.now() - entree.recu) / 1000)
            const restant = copie && copie.duree_restant
            if (ecoule > 0 && restant && typeof restant.total_secondes === 'number') restant.total_secondes -= ecoule
            return copie
        })
    },

    storeConfigHistorique(data){
        const promise = Api().post('/config/historique/store', data)
        return promise.then(response => response.data)
    },

    getHistoriqueConfig(data){
        const promise = Api().post('/config/get-historique', data)
        return promise.then(response => response.data)
    },

    getListeSectionAntecedents() {
        const promise = Api().post('/antecedents/liste')
        return promise.then((response) => response.data)
    },

    saveSectionAntecedents(data) {
        const promise = Api().post('/antecedents/section/store', data)
        return promise.then((response) => response.data)
    },

    reorderSectionAntecedents(data) {
        const promise = Api().post('/antecedents/section/reorder', data)
        return promise.then((response) => response.data)
    },

    deactivateATCDPatient(data) {
        const promise = Api().post('/antecedents/section/deactivate', data)
        return promise.then((response) => response.data)
    },

    saveModeleExamen(data) {
        const promise = Api().post('/model-examens/store', data)
        return promise.then((response) => response.data)
    },

    getListeModeleExamens(data) {
        const promise = Api().post('/model-examens/liste', data)
        return promise.then((response) => response.data)
    },

    getListeChampByModeleExamen(data) {
        const promise = Api().post('/model-examens/liste-champs', data)
        return promise.then((response) => response.data)
    },

    saveTriUrgence(data) {
        const promise = Api().post('/config/store-tri-urgence', data)
        return promise.then((response) => response.data)
    },

    getTriUrgence() {
        const promise = Api().get('/config/liste/tri-urgence')
        return promise.then((response) => response.data)
    },

    reOrderTriUrgence(data) {
        const promise = Api().post('/config/reorder/tri-urgence', data)
        return promise.then((response) => response.data)
    },

    deleteTriUrgence(data) {
        const promise = Api().post('/config/delete/tri-urgence', data)
        return promise.then((response) => response.data)
    },

    saveCoupureBilletage(data) {
        const promise = Api().post('/config/coupure-billetage/store', data)
        return promise.then((response) => response.data)
    },

    getCoupureBilletage(data_type) {
        const promise = Api().get('/config/coupure-billetage/' + data_type)
        return promise.then((response) => response.data)
    },

    updateCoupureBilletage(data) {
        const promise = Api().post('/config/coupure-billetage/update', data)
        return promise.then((response) => response.data)
    },

    removeCoupureBilletage(data) {
        const promise = Api().post('/config/coupure-billetage/remove', data)
        return promise.then((response) => response.data)
    },

    deleteLits(data) {
        const promise = Api().post('/parametres/lits/delete', data)
        return promise.then((response) => response.data)
    },

    saveLit(data) {
        const promise = Api().post('/parametres/lit/store', data)
        return promise.then((response) => response.data)
    },

    getListeOccurencesByChamp(data) {
        const promise = Api().post('/champs/occurences-by-champ', data)
        return promise.then((response) => response.data)
    },
}
